var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8814_11595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8814_11595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6663C11.6333 22.6663 11.3194 22.5358 11.0583 22.2747C10.7972 22.0136 10.6666 21.6997 10.6666 21.333V10.6663C10.6666 10.2997 10.7972 9.98579 11.0583 9.72467C11.3194 9.46356 11.6333 9.33301 12 9.33301H17.3333L21.3333 13.333V15.333C21.0777 15.3886 20.8388 15.4775 20.6166 15.5997C20.3944 15.7219 20.1888 15.8775 20 16.0663L16 20.0497V22.6663H12ZM17.3333 22.6663V20.6163L21.0166 16.9497C21.1166 16.8497 21.2277 16.7775 21.35 16.733C21.4722 16.6886 21.5944 16.6663 21.7166 16.6663C21.85 16.6663 21.9777 16.6913 22.1 16.7413C22.2222 16.7913 22.3333 16.8663 22.4333 16.9663L23.05 17.583C23.1388 17.683 23.2083 17.7941 23.2583 17.9163C23.3083 18.0386 23.3333 18.1608 23.3333 18.283C23.3333 18.4052 23.3111 18.5302 23.2666 18.658C23.2222 18.7858 23.15 18.8997 23.05 18.9997L19.3833 22.6663H17.3333ZM21.7166 18.933L22.3333 18.283L21.7166 17.6663L21.0833 18.2997L21.7166 18.933ZM16.6666 13.9997H20L16.6666 10.6663V13.9997Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.fa2c20cf668f1c5e195b7458761869dc.svg";
export { ForwardRef as ReactComponent };